export const initialState = {
    step_1: true,
    step_2: false,
    step_3: false,
    step_4: false,
    step_5: false,
    step_6: false,
    access: false,
    update: false,
    file: null,
    img1: null,
    img2: null,
    trainingVoice: null,
    importantPointsVoice: null
}

export const StepperReducer = (initialState, payload) => {
    switch (payload.type) {
        case "STEP_1":
            return {
                ...initialState,
                step_1: true,
                step_2: false
            };
        case "STEP_2":
            return {
                ...initialState,
                step_1: false,
                step_2: true,
                step_3: false,
            };
        case "STEP_3":
            return {
                ...initialState,
                step_2: false,
                step_3: true,
                step_4: false
            };
        case "STEP_4":
            return {
                ...initialState,
                step_3: false,
                step_4: true,
                step_5: false
            };
        case "STEP_5":
            return {
                ...initialState,
                step_4: false,
                step_5: true,
                step_6: false
            };
        case "STEP_6":
            return {
                ...initialState,
                step_5: false,
                step_6: true
            };
        case "UPDATE_ALL_FILES":
            return {
                ...initialState,
                trainingVoice: payload.training_voice,
                file: payload.file,
                img1: payload.img1,
                img2: payload.img2,
                importantPointsVoice: payload.important_points_voice
            };
        case "CLEARE_ALL_DATA":
            return {
                ...initialState,
                trainingVoice: null,
                file: null,
                img1: null,
                img2: null,
                importantPointsVoice: null
            };
        case "ACCESS_NEXT":
            return {
                ...initialState,
                access: payload.access,
            };
        case "SET_UPDATE":
            return {
                ...initialState,
                update: payload.update
            };
        case "UPDATE_TRAINING_VOICE":
            return {
                ...initialState,
                trainingVoice: payload.training_voice
            };
        case "UPDATE_IMPORTANT_VOICE":
            return {
                ...initialState,
                importantPointsVoice: payload.important_points_voice
            };
        case "UPDATE_VIDEO":
            return {
                ...initialState,
                file: payload.file
            }
        case "UPDATE_IMG1":
            return {
                ...initialState,
                img1: payload.img1
            };
        case "UPDATE_IMG2":
            return {
                ...initialState,
                img2: payload.img2
            };
        default:
            throw new Error(`Unhandled payload type: ${payload.type}`)
    }
}